import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PerspectiveComponent from "./PerspectiveComponent";
import ObjectivesComponent from "./ObjectivesComponent";
import KPIsComponent from "./KPIsComponent";
import { useRouteMatch, Switch, Route } from "react-router-dom";
import { Button } from "../../../ui/Button";
import Modal from "../../../ui/Modal";
import Preview from "./ScorecardPreview/Preview";
import { is360Subject } from "../../../subjects/Is360Subject";
import KPIComponent360 from "./KPIComponent360";
import PreviewContainer from "./ScorecardPreview/PreviewContainer";
import { GetHook } from "../../../api/api";
import { SCORECARD_URL } from "../../../api/urls";
import { PreviewSubject } from "../../../subjects/PreviewSubject";

export const ScorecardSettings = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [step, setStep] = useState(0);
  const { path, params } = useRouteMatch<any>();
  const { id } = params;

  const { data: scorecard } = GetHook(`${SCORECARD_URL}/${id}/summary`);

  const is360 = is360Subject.value;

  useEffect(() => {
    const initialStep = PreviewSubject.subscribe((payload) => setStep(payload));
    return () => {
      initialStep.unsubscribe();
    };
  }, []);


  return (
    <ScorecardSettingsContainer>
      <PreviewButton
        text="Preview"
        backgroundColor="#fff"
        color="#D51067"
        onClick={() => setisModalOpen(true)}
      />
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <PerspectiveComponent openPreviewModal={setisModalOpen} />
          )}
        />
      </Switch>
      <Route
        path={`${path}/perspective/:id`}
        render={() => (
          <ObjectivesComponent scorecard={scorecard} scorecard_id={params.id} />
        )}
      />
      <Route
        path={`${path}/perspective/:id/objective/:id`}
        render={() =>
          is360 ? (
            <KPIComponent360 scorecard={scorecard} scorecard_id={params.id} />
          ) : (
            <KPIsComponent scorecard={scorecard} scorecard_id={params.id} />
          )
        }
      />
      {isModalOpen && (
        <Modal
          title={"preview"}
          closeModal={() => setisModalOpen(false)}
          noHeader
          width={"70%"}
          noFooter
        >
          <PreviewContainer
            scorecardId={id}
            initialStep={step}
            closeModal={() => setisModalOpen(false)}
          />
        </Modal>
      )}
    </ScorecardSettingsContainer>
  );
};

const ScorecardSettingsContainer = styled.div`
  display: grid;
  background-color: #fff;
  grid-template-columns: 22em 22em auto;
  box-shadow: 0px 10px 20px rgba(55, 81, 255, 0.1);
`;

const PreviewButton = styled(Button)`
  border: 1px solid #D51067;
  padding: 1em 2em;
  position: absolute;
  right: 3em;
  top: 8em;
`;
